var React = require('react');

function MobilityScooterHireInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"strokeLinecap":"square","cx":"13","cy":"52","r":"6","key":0}),React.createElement("circle",{"strokeLinecap":"square","cx":"49","cy":"52","r":"6","key":1}),React.createElement("path",{"d":"M10.5 16l4 30m28-15L47 46m-28 6h24M14 41h24.5m5.5-6h13v6H45.5","key":2}),React.createElement("circle",{"strokeLinecap":"square","cx":"20","cy":"11","r":"5","key":3}),React.createElement("path",{"d":"M44 49l-8-12H21.557a4 4 0 0 1-3.973-3.533l-1.453-12.35A1 1 0 0 1 17.125 20h6.231a1 1 0 0 1 .91.586l4.201 9.242A2 2 0 0 0 30.287 31H35","key":4})]));
}

MobilityScooterHireInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = MobilityScooterHireInline;

MobilityScooterHireInline.default = MobilityScooterHireInline;
